import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";


export class LotModel extends BaseModel {
  title = null
  lot_no = null
  message = null
  rules = {}

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}

export class ConditionReportRequestModalModel extends BaseModel {
  reservations = []
  customer_first_name = null
  customer_last_name = null
  customer_email = null
  customer_uuid = null
  customer = null
  rules = {}

  attributeLabels = {
    reservations: i18n.t('Lots'),
    customer_first_name: i18n.t('Customer First Name'),
    customer_last_name: i18n.t('Customer Last Name'),
    customer_email: i18n.t('Customer Email'),
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
